"use client";
import { createContext, useContext } from "react";
const ButtonGroupContext = /*#__PURE__*/ createContext({});
function useButtonGroupContext() {
    return useContext(ButtonGroupContext);
}
export { ButtonGroupContext, useButtonGroupContext };
